module.exports = function(bootstrap) {
    bootstrap.run(['Service', function(Service) {
        new Service(
            {
                name: 'visitedMHSLanding',
                group: 'rbsmbl',
                cache: false,
                url: '/rbsmbl/x-services/updateMetrics/visitedMHSLanding',

                fetch: function(userId) {
                    return this.get({ userId: userId });
                }
            }
        );
    }]);
};